"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../../container"));
var generation_1 = require("../../stores/generation");
var fetchGenerationSettings_1 = __importDefault(require("./fetchGenerationSettings"));
var generation_2 = require("../../selectors/generation");
function fetchGenerationLastUpdated() {
    var _this = this;
    var action = function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var logger, request, lastUpdated, lastLocalGenerationUpdate, equal, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/fetchGenerationLastUpdated");
                    request = _kernel_container_1.default.get("REQUEST");
                    if ((0, generation_2.selectGenerationSettingsAreFetching)(getState())) {
                        logger.debug("Last update for generation settings or settings are already fetching");
                        return [2];
                    }
                    if ((0, generation_2.selectGenerationFetchLocked)(getState())) {
                        logger.debug("Last update for generation settings is currently locked");
                        return [2];
                    }
                    dispatch((0, generation_1.setGenerationMetadata)({
                        isLastUpdateFetching: true,
                    }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    logger.debug("Fetching generation last updated");
                    return [4, request.getGenerationLastUpdated()];
                case 2:
                    lastUpdated = _a.sent();
                    lastLocalGenerationUpdate = (0, generation_2.selectLastGenerationUpdate)(getState());
                    equal = lastLocalGenerationUpdate === lastUpdated.getTime();
                    if (!equal) {
                        dispatch((0, generation_1.setGenerationMetadata)({
                            lastBackendSettingsUpdate: lastUpdated.getTime(),
                        }));
                        dispatch((0, fetchGenerationSettings_1.default)());
                    }
                    return [3, 5];
                case 3:
                    e_1 = _a.sent();
                    logger.error("Error fetching last generation settings update", {
                        error: e_1.toString(),
                    });
                    return [3, 5];
                case 4:
                    logger.debug("Done fetching last generation settings update");
                    dispatch((0, generation_1.setGenerationMetadata)({
                        isLastUpdateFetching: false,
                        lastLastUpdateFetch: Date.now(),
                    }));
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    action.type = "fetchGenerationLastUpdated";
    return action;
}
exports.default = fetchGenerationLastUpdated;
//# sourceMappingURL=fetchGenerationLastUpdated.js.map